var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.5C5.52538 8.50065 6.04571 8.39748 6.5311 8.19641C7.01649 7.99535 7.45736 7.70037 7.8284 7.3284C8.20037 6.95736 8.49535 6.51649 8.69641 6.0311C8.89748 5.54571 9.00065 5.02538 9 4.5C9.00065 3.97462 8.89748 3.45429 8.69641 2.9689C8.49535 2.48351 8.20037 2.04264 7.8284 1.6716C7.45736 1.29963 7.01649 1.00465 6.5311 0.803586C6.04571 0.602525 5.52538 0.499355 5 0.500003C4.47462 0.499355 3.95429 0.602525 3.4689 0.803586C2.98351 1.00465 2.54264 1.29963 2.1716 1.6716C1.79963 2.04264 1.50465 2.48351 1.30359 2.9689C1.10253 3.45429 0.999355 3.97462 1 4.5C0.999355 5.02538 1.10253 5.54571 1.30359 6.0311C1.50465 6.51649 1.79963 6.95736 2.1716 7.3284C2.54264 7.70037 2.98351 7.99535 3.4689 8.19641C3.95429 8.39748 4.47462 8.50065 5 8.5Z",
    stroke: "#6CC271",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.40002 4.49993L4.60002 5.69993L7.00002 3.29993",
    stroke: "#6CC271",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.c1004f15.svg";
export { ForwardRef as ReactComponent };